import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon } from 'antd'

import { policyType } from '@texts/policy'

@inject((store: any) => {
    const { popupStore, termsStore, termCollectionsStore, collectionsStore } = store
    return { popupStore, termsStore, termCollectionsStore, collectionsStore }
})
@observer
export default class RightsPopup extends Component<any, any> {
    state: any = {
        errors: {},
        term: null
    }

    handlePageChange = page => {
        this.props.termsStore.changePage(page)
    }

    handleAddTerm = term => {
        this.props.termsStore.addTerm(term)
        this.props.termCollectionsStore.resetList()
        this.closePopup()
    }

    toggleTerm = id => {
        if (id !== this.state.term) {
            this.setState({ term: id })
        } else {
            this.setState({ term: null })
        }
    }

    handleSearch = () => {
        const { termsStore } = this.props
        termsStore.resetPagingation()
        termsStore.getFilteredList()
    }

    handleSearchCollection = async term_id => {
        const { collectionsStore } = this.props
        await collectionsStore.resetFilters()
        await collectionsStore.setFilter('term_id', term_id)
        await collectionsStore.getCollections(1)
        this.closePopup()
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, termsStore } = this.props

        return (
            <Modal
                title={'בחירת תנאי קיים לשיוך'}
                visible={popupStore.popupType === 'termsList'}
                cancelText="ביטול"
                onCancel={this.closePopup}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <div style={{ display: 'flex', marginBottom: '1rem' }}>
                        <Input.Search
                            style={{ width: '60%' }}
                            placeholder="חיפוש כותרת / תיאור"
                            value={termsStore.filters.textSearch ? termsStore.filters.textSearch : null}
                            onChange={e => termsStore.setFilter('textSearch', e.target.value)}
                        />
                        <Input.Search
                            style={{ width: '40%', marginRight: '0.3rem' }}
                            placeholder="חיפוש מזהה"
                            value={termsStore.filters.id ? termsStore.filters.id : null}
                            onChange={e => termsStore.setFilter('id', e.target.value)}
                        />
                        <div style={{ display: 'flex' }}>
                            <Button style={{ margin: '0 0.2rem' }} onClick={() => termsStore.resetFilters()}>
                                איפוס
                            </Button>
                            <Button style={{ margin: '0' }} onClick={() => this.handleSearch()} type="primary">
                                חפש
                            </Button>
                        </div>
                    </div>
                    <List
                        dataSource={termsStore.filteredList}
                        renderItem={item => {
                            let link
                            let bg = 'initial'
                            if (popupStore.info.action) {
                                link = (
                                    <a
                                        style={{ textDecoration: 'underline' }}
                                        onClick={() => this.handleSearchCollection(item['id'])}
                                    >
                                        החל סינון
                                    </a>
                                )
                            } else {
                                const existing = termsStore.list.find(existing => existing.id === item['id'])
                                if (existing) bg = '#fbdbbc'
                                link = existing ? (
                                    'תנאי זה כבר מקושר'
                                ) : (
                                    <a style={{ textDecoration: 'underline' }} onClick={() => this.handleAddTerm(item)}>
                                        <Icon type="link" /> קשר תנאי
                                    </a>
                                )
                            }

                            return (
                                <List.Item
                                    key={item['id']}
                                    style={{
                                        textAlign: 'right',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                        padding: '0.5rem',
                                        backgroundColor: bg
                                    }}
                                >
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div onClick={() => this.toggleTerm(item['id'])}>
                                            <Icon type={`${this.state.term == item['id'] ? 'down' : 'left'}`} />
                                            <span style={{ marginRight: '1rem' }}>{item['id']}</span> |
                                            {item['title'] ? item['title'] : '-- אין כותרת ותיאור'}
                                            <span>({item['termCollections'].length} זכויות)</span>
                                        </div>
                                        <div style={{ whiteSpace: 'nowrap' }}>{link}</div>
                                    </div>
                                    {this.state.term == item['id'] ? (
                                        <div style={{ width: '100%', padding: '0.5rem' }}>
                                            {item['description'] ? (
                                                <div
                                                    className="text-box"
                                                    dangerouslySetInnerHTML={{ __html: item['description'] }}
                                                />
                                            ) : (
                                                'ללא תיאור'
                                            )}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </List.Item>
                            )
                        }}
                        pagination={{
                            hideOnSinglePage: true,
                            total: termsStore.pagination.total,
                            current: termsStore.pagination.page,
                            onChange: e => this.handlePageChange(e)
                        }}
                    />
                </div>
            </Modal>
        )
    }
}
